exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".speaker-card[data-v-35be9c0a] {\n  display: block;\n  position: relative;\n}\n.speaker-card .image-wrapper[data-v-35be9c0a] {\n  overflow: hidden;\n  border-radius: 4px;\n  position: relative;\n}\n.speaker-card .image-wrapper img[data-v-35be9c0a] {\n  position: absolute;\n  top: 0px;\n  bottom: 0px;\n  left: 0px;\n  right: 0px;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  font-family: \"object-fit: cover;\";\n  transition: transform 0.15s;\n}\n.speaker-card .xsmall[data-v-35be9c0a] {\n  line-height: 1.2;\n}\n.speaker-card:hover img[data-v-35be9c0a] {\n  transform: scale(1.1);\n}", ""]);

// exports
